import React from 'react'
import { useTranslation } from 'react-i18next'

import { SeoHead } from './SeoHead'

import {
  combineSchemas,
  createOrganizationSchema,
  createWebSiteSchema,
} from '../../../utils'

export const HomeHead: React.FC = () => {
  const { t, i18n } = useTranslation()

  const baseUrl = 'https://booking.hkdballpark.com'
  // canonical / og:url はクエリ文字列を含めない (SNS キャッシュ分散・Functions 側と統一)
  const currentUrl = baseUrl

  // Combine all structured data for home page
  const structuredData = combineSchemas(
    createOrganizationSchema(),
    createWebSiteSchema(baseUrl)
  )

  const isJapanese = i18n.language === 'ja'

  return (
    <SeoHead
      title={t('meta.pages.root.title')}
      description={t('meta.pages.root.description')}
      canonical={baseUrl}
      ogTitle={
        isJapanese
          ? 'Fビレッジ宿泊予約 - 北海道ボールパーク'
          : 'F Village Hotel Booking - Hokkaido Ballpark'
      }
      ogUrl={currentUrl}
      ogType="website"
      ogSiteName="北海道ボールパークFビレッジ"
      twitterCard="summary_large_image"
      twitterSite="@ballpark_htb"
      structuredData={structuredData}
      alternateLanguages={[
        { lang: 'ja', href: baseUrl },
        { lang: 'en', href: `${baseUrl}?lang=en` },
      ]}
    />
  )
}
